import React, { createContext, useContext, useState, useEffect } from "react";
import config from "../config";

const GradeContext = createContext();

export function GradeProvider({ children }) {
  const [grade, setGrade] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `${config.apiBaseUrl}/grades/classes.php?action=list`
        );

        const json = await res.json();

        console.log("GradeContext API:", json);

        // 🔥 Handle direct array response
        const data = Array.isArray(json)
          ? json
          : json.data || [];

        const normalized = data.map(cls => ({
          value: cls.class_id,
          grade_id: cls.grade_id,
          grade_name: cls.grade_name,
          section_name: cls.section_name,
          academic_year: cls.academic_year,
          label: `Class-${cls.grade_name} - ${cls.section_name} (${cls.academic_year})`
        }));

        setGrade(normalized);

      } catch (error) {
        console.error("Error fetching classes:", error);
        setGrade([]);
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refreshData = () => fetchData();

  return (
    <GradeContext.Provider value={{ grade, loading, refreshData }}>
      {children}
    </GradeContext.Provider>
  );
}

export function useGrade() {
  const context = useContext(GradeContext);
  if (!context) {
    throw new Error("useGrade must be used within a GradeProvider");
  }
  return context;
}